module.exports = __webpack_public_path__ + "img/zbbs-nav.8956bf3.svg";